import firebase, { firebaseConfig } from "./firebase";
import { getAuth } from "firebase/auth";
import "firebaseui/dist/firebaseui.css";
import { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router";
import { AppColors } from "./theme/colors";

const firebaseui = require("firebaseui");

function InitAuth() {
  const [authentication, setAuthState] = useState(true);
  const [isVisible, setIsVisible] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const unsub = getAuth().onAuthStateChanged((user) => {
      if (user) {
        setAuthState(true);
        console.log("Logged in");
      } else {
        setAuthState(false);
        console.log("Logged out!!");
      }
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    const id = window.setTimeout(() => {
      setIsVisible(authentication);
    }, 500);
    return () => window.clearTimeout(id);
  }, [authentication]);

  const uiConfig = {
    callbacks: {
      uiShown: function () {
        // no-op
      },
    },
    signInSuccessUrl: "jarvis",
    signInOptions: [
      {
        // Leave the lines as is for the providers you want to offer your users.
        //firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        //firebase.auth.FacebookAuthProvider.PROVIDER_ID,
        //firebase.auth.TwitterAuthProvider.PROVIDER_ID,
        //firebase.auth.GithubAuthProvider.PROVIDER_ID,
        //firebase.auth.PhoneAuthProvider.PROVIDER_ID,
        //firebaseui.auth.AnonymousAuthProvider.PROVIDER_ID,
        provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
        disableSignUp: {
          status: true, // toggle this if I want to be able to log in,
          adminEmail: "ayush@acchaudhary.com",
        },
      },
    ],

    // tosUrl and privacyPolicyUrl accept either url string or a callback
    // function.
    // Terms of service url/callback.
    tosUrl: "/termsOfService",
    // Privacy policy url/callback.
    privacyPolicyUrl: function () {
      window.location.assign("<your-privacy-policy-url>");
    },
  };

  // Initialize the FirebaseUI Widget using Firebase.
  useEffect(() => {
    if (firebaseui.auth.AuthUI.getInstance()) {
      const ui = firebaseui.auth.AuthUI.getInstance();
      ui.start("#firebaseui-auth-container", uiConfig);
    } else {
      const ui = new firebaseui.auth.AuthUI(firebase.auth());
      ui.start("#firebaseui-auth-container", uiConfig);
    }
  }, [authentication]);

  return (
    <div>
      <h3 className="h31"> {authentication ? "Authenticated" : "Log-in"}</h3>

      <div hidden={authentication} id="firebaseui-auth-container"></div>

      {isVisible ? (
        <Box
          hidden={!authentication}
          display="flex"
          flexDirection="column"
          rowGap={2}
        >
          <Button
            variant="contained"
            sx={{ backgroundColor: AppColors.dashboardBlue }}
            onClick={() => {
              navigate("/jarvis");
            }}
          >
            Dashboard
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              //login.current.style.display = 'default';
              firebase.auth().signOut();
              console.log("Signed out");
              navigate("/");
            }}
          >
            Log-out
          </Button>
        </Box>
      ) : (
        <>
          <a className="h31">ACC</a>
        </>
      )}
    </div>
  );
}

export default InitAuth;
export { firebaseConfig };
